import React from 'react';
import SSButton from '../SSButton';
import { trackEvents } from '../../utils/analytics';
import { getSessionStorage } from '../../utils';

import './aitab.scss';
export default function AITab({ showTrainingTab, handleAITabClick }) {
  const profiles = getSessionStorage('current-profile');

  return (
    <div className={showTrainingTab ? 'ai-tab-container low' : 'ai-tab-container valid'}>
      <h2>
        {showTrainingTab ? (
          <span>We recommend a training score of minimum 50% for optimum results.</span>
        ) : (
          <span>You are ready to install and use Sales Stack apps!</span>
        )}
      </h2>
      <SSButton
        classBtn={'ai-tab-btn'}
        type={'filled'}
        btnText={showTrainingTab ? 'train ai' : 'install apps'}
        onClickHandle={() => {
          if (!showTrainingTab) trackEvents('view_item_list', { userId: profiles.userId });
          handleAITabClick();
        }}
      />
    </div>
  );
}
